import styled from 'styled-components'

export const Labels = styled.div`
  display: flex;
  gap: 10px;
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const Square = styled.div`
  width: 20px;
  height: 20px;
  background: ${({ color }) => (color ? color : 'red')};
`

export const Text = styled.strong`
  margin: 0;
`
